var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 37,
    viewBox: "0 0 34 37",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#faf7f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 14.748h33.6622v7.08678h-33.6622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5752 14.748h7.08678v7.08678h-7.08678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.4883 7.66016h7.08678v7.08678h-7.08678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.4883 21.832h7.08678v7.08678h-7.08678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.4004.574219h7.08678v7.08678h-7.08678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.4004 28.9219h7.08678v7.08678h-7.08678z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f457c8982bb13d520bf1e341310aeb98.svg";
export { ForwardRef as ReactComponent };